import React from 'react'

const Ggle15 = () => {
    return (
        <div className='container'>
          <h1>Modular Exponentiation (Power in Modular Arithmetic)</h1>
          <p>Given three numbers x, y and p, compute (x<sup>y</sup>) % p.&nbsp;</p>
          <p><strong>Examples :</strong>&nbsp;</p>
          <pre className='containers'><strong>Input:</strong>  x = 2, y = 3, p = 5 <br />
<strong>Output:</strong> 3 <br />
<strong>Explanation:</strong> 2^3 % 5 = 8 % 5 = 3. <br />
 <br />
<strong>Input:</strong>  x = 2, y = 5, p = 13 <br />
<strong>Output:</strong> 6 <br />
<strong>Explanation:</strong> 2^5 % 13 = 32 % 13 = 6.</pre>
<p><strong>Efficient Approach:</strong></p>
<p>The problem with above solutions is, overflow may occur for large value of n or x. Therefore, power is generally evaluated under modulo of a large number.</p>
<p>Below is the fundamental modular property that is used for efficiently computing power under modular arithmetic.&nbsp;</p>
<pre>{`(ab) mod p = ( (a mod p) (b mod p) ) mod p 

For example a = 50,  b = 100, p = 13
50  mod 13  = 11
100 mod 13  = 9

(50 * 100) mod 13 = ( (50 mod 13) * (100 mod 13) ) mod 13 
or (5000) mod 13 = ( 11 * 9 ) mod 13
or 8 = 8`}</pre>
                    <div class="tabs">
    <input type="radio" name="tab" id="tab1" checked="checked"/>
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
  
  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
        <div class="line number1 index0 alt2"><code
                        class="comments">// Iterative C++ program to compute modular power</code></div>
        <div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;iostream&gt;</code></div>
        <div class="line number3 index2 alt2"><code class="keyword bold">using</code> <code
                        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
        <div class="line number4 index3 alt1">&nbsp;</div>
        <div class="line number5 index4 alt2"><code
                        class="comments">/* Iterative Function to calculate (x^y)%p in O(log y) */</code></div>
        <div class="line number6 index5 alt1"><code class="color1 bold">int</code> <code
                        class="plain">power(</code><code class="color1 bold">long</code> <code
                        class="color1 bold">long</code> <code class="plain">x, unsigned </code><code
                        class="color1 bold">int</code> <code class="plain">y, </code><code
                        class="color1 bold">int</code> <code class="plain">p)</code></div>
        <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div>
        <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">res = 1;&nbsp;&nbsp;&nbsp;&nbsp; </code><code
                        class="comments">// Initialize result</code></div>
        <div class="line number9 index8 alt2">&nbsp;</div>
        <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">x = x % p; </code><code class="comments">// Update x if it is more than or</code>
        </div>
        <div class="line number11 index10 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments">// equal to p</code></div>
        <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">if</code> <code class="plain">(x == 0) </code><code
                        class="keyword bold">return</code> <code class="plain">0; </code><code
                        class="comments">// In case x is divisible by p;</code></div>
        <div class="line number14 index13 alt1">&nbsp;</div>
        <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">while</code> <code class="plain">(y &gt; 0)</code></div>
        <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number17 index16 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments">// If y is odd, multiply x with result</code></div>
        <div class="line number18 index17 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">if</code> <code class="plain">(y &amp; 1)</code></div>
        <div class="line number19 index18 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">res = (res*x) % p;</code></div>
        <div class="line number20 index19 alt1">&nbsp;</div>
        <div class="line number21 index20 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments">// y must be even now</code></div>
        <div class="line number22 index21 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">y = y&gt;&gt;1; </code><code class="comments">// y = y/2</code></div>
        <div class="line number23 index22 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">x = (x*x) % p;</code></div>
        <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">return</code> <code class="plain">res;</code></div>
        <div class="line number26 index25 alt1"><code class="plain">&#125;</code></div>
        <div class="line number27 index26 alt2">&nbsp;</div>
        <div class="line number28 index27 alt1"><code class="comments">// Driver code</code></div>
        <div class="line number29 index28 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number30 index29 alt1"><code class="plain">&#123;</code></div>
        <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">x = 2;</code></div>
        <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">y = 5;</code></div>
        <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">p = 13;</code></div>
        <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"Power is "</code> <code
                        class="plain">&lt;&lt; power(x, y, p);</code></div>
        <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword bold">return</code> <code class="plain">0;</code></div>
        <div class="line number36 index35 alt1"><code class="plain">&#125;</code></div>
        <div class="line number37 index36 alt2">&nbsp;</div>
        <div class="line number38 index37 alt1"><code
                        class="comments">// This code is contributed by shubhamsingh10</code></div>
</div>
       </div>
      <div id="tab-content-2" class="tab-content">
      <div class="container">
        <div class="line number1 index0 alt2"><code
                        class="comments">// Iterative Java program to compute modular power</code></div>
        <div class="line number2 index1 alt1"><code class="keyword">import</code> <code class="plain">java.io.*;</code>
        </div>
        <div class="line number3 index2 alt2"><code class="keyword">class</code> <code class="plain">GFG</code></div>
        <div class="line number4 index3 alt1"><code class="plain">&#123;</code></div>
        <div class="line number5 index4 alt2">&nbsp;</div>
        <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
                        class="comments">/* Iterative Function to calculate (x^y) in O(log y) */</code></div>
        <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
                        class="keyword">static</code> <code class="keyword">int</code> <code
                        class="plain">power(</code><code class="keyword">int</code> <code class="plain">x, </code><code
                        class="keyword">int</code> <code class="plain">y, </code><code class="keyword">int</code> <code
                        class="plain">p)</code></div>
        <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">int</code> <code class="plain">res = </code><code class="value">1</code><code
                        class="plain">; </code><code class="comments">// Initialize result</code></div>
        <div class="line number10 index9 alt1">&nbsp;</div>
        <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">x = x % p; </code><code class="comments">// Update x if it is more than or</code>
        </div>
        <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments">// equal to p</code></div>
        <div class="line number13 index12 alt2">&nbsp;</div>
        <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">if</code> <code class="plain">(x == </code><code class="value">0</code><code
                        class="plain">)</code></div>
        <div class="line number15 index14 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">return</code> <code class="value">0</code><code class="plain">; </code><code
                        class="comments">// In case x is divisible by p;</code></div>
        <div class="line number16 index15 alt1">&nbsp;</div>
        <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">while</code> <code class="plain">(y &gt; </code><code
                        class="value">0</code><code class="plain">)</code></div>
        <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number19 index18 alt2">&nbsp;</div>
        <div class="line number20 index19 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments">// If y is odd, multiply x with result</code></div>
        <div class="line number21 index20 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">if</code> <code class="plain">((y &amp; </code><code class="value">1</code><code
                        class="plain">) != </code><code class="value">0</code><code class="plain">)</code></div>
        <div class="line number22 index21 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">res = (res * x) % p;</code></div>
        <div class="line number23 index22 alt2">&nbsp;</div>
        <div class="line number24 index23 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments">// y must be even now</code></div>
        <div class="line number25 index24 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">y = y &gt;&gt; </code><code class="value">1</code><code
                        class="plain">; </code><code class="comments">// y = y/2</code></div>
        <div class="line number26 index25 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">x = (x * x) % p;</code></div>
        <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">return</code> <code class="plain">res;</code></div>
        <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number30 index29 alt1">&nbsp;</div>
        <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
                        class="comments">// Driver Code</code></div>
        <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
                        class="keyword">public</code> <code class="keyword">static</code> <code
                        class="keyword">void</code> <code class="plain">main(String[] args)</code></div>
        <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">int</code> <code class="plain">x = </code><code class="value">2</code><code
                        class="plain">;</code></div>
        <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">int</code> <code class="plain">y = </code><code class="value">5</code><code
                        class="plain">;</code></div>
        <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">int</code> <code class="plain">p = </code><code class="value">13</code><code
                        class="plain">;</code></div>
        <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">System.out.print(</code><code class="string">"Power is "</code> <code
                        class="plain">+ power(x, y, p));</code></div>
        <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number39 index38 alt2"><code class="plain">&#125;</code></div>
        <div class="line number40 index39 alt1">&nbsp;</div>
        <div class="line number41 index40 alt2"><code
                        class="comments">// This code is contributed by Dharanendra L V.</code></div>
</div>
        </div>
       <div id="tab-content-3" class="tab-content">
       <div class="container">
        <div class="line number1 index0 alt2"><code class="comments"># Iterative Python3 program</code></div>
        <div class="line number2 index1 alt1"><code class="comments"># to compute modular power</code></div>
        <div class="line number3 index2 alt2">&nbsp;</div>
        <div class="line number4 index3 alt1"><code class="comments"># Iterative Function to calculate</code></div>
        <div class="line number5 index4 alt2"><code class="comments"># (x^y)%p in O(log y)</code></div>
        <div class="line number6 index5 alt1"><code class="keyword">def</code> <code
                        class="plain">power(x, y, p) :</code></div>
        <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">res </code><code class="keyword">=</code> <code
                        class="value">1</code>&nbsp;&nbsp;&nbsp;&nbsp; <code class="comments"># Initialize result</code>
        </div>
        <div class="line number8 index7 alt1">&nbsp;</div>
        <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments"># Update x if it is more</code></div>
        <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments"># than or equal to p</code></div>
        <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">x </code><code class="keyword">=</code> <code class="plain">x </code><code
                        class="keyword">%</code> <code class="plain">p</code></div>
        <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
        </div>
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">if</code> <code class="plain">(x </code><code class="keyword">=</code><code
                        class="keyword">=</code> <code class="value">0</code><code class="plain">) :</code></div>
        <div class="line number14 index13 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">return</code> <code class="value">0</code></div>
        <div class="line number15 index14 alt2">&nbsp;</div>
        <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">while</code> <code class="plain">(y &gt; </code><code
                        class="value">0</code><code class="plain">) :</code></div>
        <div class="line number17 index16 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number18 index17 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments"># If y is odd, multiply</code></div>
        <div class="line number19 index18 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments"># x with result</code></div>
        <div class="line number20 index19 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">if</code> <code class="plain">((y &amp; </code><code class="value">1</code><code
                        class="plain">) </code><code class="keyword">=</code><code class="keyword">=</code> <code
                        class="value">1</code><code class="plain">) :</code></div>
        <div class="line number21 index20 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">res </code><code class="keyword">=</code> <code class="plain">(res </code><code
                        class="keyword">*</code> <code class="plain">x) </code><code class="keyword">%</code> <code
                        class="plain">p</code></div>
        <div class="line number22 index21 alt1">&nbsp;</div>
        <div class="line number23 index22 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comments"># y must be even now</code></div>
        <div class="line number24 index23 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">y </code><code class="keyword">=</code> <code
                        class="plain">y &gt;&gt; </code><code class="value">1</code>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <code
                        class="comments"># y = y/2</code></div>
        <div class="line number25 index24 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">x </code><code class="keyword">=</code> <code class="plain">(x </code><code
                        class="keyword">*</code> <code class="plain">x) </code><code class="keyword">%</code> <code
                        class="plain">p</code></div>
        <div class="line number26 index25 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keyword">return</code> <code class="plain">res</code></div>
        <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
        </div>
        <div class="line number29 index28 alt2">&nbsp;</div>
        <div class="line number30 index29 alt1"><code class="comments"># Driver Code</code></div>
        <div class="line number31 index30 alt2">&nbsp;</div>
        <div class="line number32 index31 alt1"><code class="plain">x </code><code class="keyword">=</code> <code
                        class="value">2</code><code class="plain">; y </code><code class="keyword">=</code> <code
                        class="value">5</code><code class="plain">; p </code><code class="keyword">=</code> <code
                        class="value">13</code></div>
        <div class="line number33 index32 alt2"><code class="functions">print</code><code class="plain">(</code><code
                        class="string">"Power is "</code><code class="plain">, power(x, y, p))</code></div>
        <div class="line number34 index33 alt1">&nbsp;</div>
        <div class="line number35 index34 alt2">&nbsp;</div>
        <div class="line number36 index35 alt1"><code
                        class="comments"># This code is contributed by Nikita Tiwari.</code></div>
</div>
       </div>
      
      </div>
  </div>
        </div>
    )
}

export default Ggle15
